import typeToReducer from 'type-to-reducer'
import { AUTH_SUCCESS, AUTH_FAIL, AUTH_SIGNOUT, SET_AUTH_REDIRECT_PATH } from '../actions/actionTypes';


const initialState = {
    token: null,
    username: null,
    customerId: null,
    restaurantId: null,
    error: null,
    authRedirectPath: '/dashboard'
};

const reducer = typeToReducer({
    [AUTH_SUCCESS]: (state, action) => {
        return {
            ...state,
            token: action.payload.auth_token,
            username: action.payload.username,
            customerId: action.payload.pk,
            restaurantId: action.payload.restaurant_id,
            error: null
        }
    },
    [AUTH_FAIL]: (state, action) => ({
        ...state,
        error: action.error
    }),
    [AUTH_SIGNOUT]: (state, action) => ({
        ...state,
        token: null,
        username: null,
        customerId: null,
    }),
    [SET_AUTH_REDIRECT_PATH]: (state, action) => ({
        ...state,
        authRedirectPath: action.payload
    })
}, initialState);


export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/auth.js